class DocumentContext{
  static documentIds : number[];
}

export default DocumentContext;